import React from 'react';
import { clsx } from 'clsx';
import { useTab } from '@/hooks/tab';
import { Tab } from '@/types/hashes';
import Item from '@/components/organisms/sidebar/Item';
import Order from '@/components/organisms/sidebar/Order';
import Email from '@/components/organisms/sidebar/Email';
import LoginId from '@/components/organisms/sidebar/LoginId';
import PhoneNumber from '@/components/organisms/sidebar/PhoneNumber';
import styles from './Sidebar.module.scss';

const View: React.FC = () => {
  const [tab] = useTab();

  const getTabContentComp = () => {
    switch (tab) {
      case Tab.ITEM:
        return <Item />;
      case Tab.ORDER:
        return <Order />;
      case Tab.EMAIL:
        return <Email />;
      case Tab.LOGIN_ID:
        return <LoginId />;
      case Tab.PHONE_NUMBER:
        return <PhoneNumber />;
      default:
        return <></>;
    }
  };

  return (
    <div
      className={styles.container}
      data-cy="SideBar"
    >
      <div
        className={clsx(styles.wrapper)}
        data-cy="SideBar-wrapper"
      >
        {getTabContentComp()}
      </div>
    </div>
  );
};

export default View;
